export default "__VITE_ASSET__B0q5pkOQ__"